import { render, staticRenderFns } from "./FiksuCityLogo.vue?vue&type=template&id=8c5ffa68&scoped=true&"
import script from "./FiksuCityLogo.vue?vue&type=script&lang=js&"
export * from "./FiksuCityLogo.vue?vue&type=script&lang=js&"
import style0 from "./FiksuCityLogo.vue?vue&type=style&index=0&id=8c5ffa68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ffa68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c5ffa68')) {
      api.createRecord('8c5ffa68', component.options)
    } else {
      api.reload('8c5ffa68', component.options)
    }
    module.hot.accept("./FiksuCityLogo.vue?vue&type=template&id=8c5ffa68&scoped=true&", function () {
      api.rerender('8c5ffa68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logo/FiksuCityLogo.vue"
export default component.exports